import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';
import { 
  signInWithGoogle, 
  sendPasswordlessLink 
} from '../firebase';
import sonoranLandscape from '../assets/images/dither-sonora.png';
import GoogleIcon from '../components/ui/GoogleIcon';

const SignupPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleGoogleSignIn = async () => {
    if (!termsAccepted) {
      setError('You must agree to the Terms of Service and Privacy Policy.');
      return;
    }
    setLoading(true);
    setError('');
    setMessage('');
    try {
      await signInWithGoogle();
      navigate('/profile');
    } catch (error) {
      console.error('Google Sign-In Error:', error);
      setError('Failed to sign in with Google. Please try again.');
    }
    setLoading(false);
  };

  const handleEmailSignUp = async (event) => {
    event.preventDefault();
    if (!termsAccepted) {
      setError('You must agree to the Terms of Service and Privacy Policy.');
      return;
    }
    setLoading(true);
    setError('');
    setMessage('');
    const result = await sendPasswordlessLink(email);
    if (result.success) {
      // Redirect to waiting page
      navigate('/passwordless-waiting', { state: { email, isSignup: true } });
    } else {
      setError('Failed to send sign-up link. Please check the email and try again.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-form-wrapper">
        <h2 className="auth-title">CREATE YOUR ACCOUNT</h2>
        {message && <p className="auth-message success">{message}</p>}
        {error && <p className="auth-message error">{error}</p>}
        <form onSubmit={handleEmailSignUp} className="auth-form">
          <div className="auth-input-group">
            <label htmlFor="email">EMAIL ADDRESS</label>
            <input 
              type="email" 
              id="email" 
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)} 
              required 
              disabled={loading}
              placeholder="Enter your email address"
            />
          </div>
          <div className="auth-checkbox-group">
            <input 
              type="checkbox" 
              id="terms" 
              name="terms" 
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              required 
              disabled={loading}
            />
            <label htmlFor="terms">
              I AGREE TO <a href="/terms" target="_blank">TERMS OF SERVICE</a> AND <a href="/privacy" target="_blank">PRIVACY POLICY</a>
            </label>
          </div>
          <button type="submit" className="auth-button primary" disabled={loading}>
            {loading ? 'SENDING LINK...' : 'SEND SIGN-UP LINK'}
          </button>
        </form>
        <button onClick={handleGoogleSignIn} className="auth-button google" disabled={loading}>
          <GoogleIcon />
          <span>{loading ? 'SIGNING UP...' : 'CONTINUE WITH GOOGLE'}</span>
        </button>
        <p className="auth-redirect-link">
          ALREADY HAVE ONE? <a href="/login">LOG IN HERE.</a>
        </p>
      </div>
      <div className="auth-image-wrapper">
        <img src={sonoranLandscape} alt="Desert landscape" />
      </div>
    </div>
  );
};

export default SignupPage; 